import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VirtualGallery from './components/VirtualGallery';
import './i18n/i18n'; // Initialize i18n

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<VirtualGallery />} />
          <Route path="/gallery/:hallId" element={<VirtualGallery />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;